import type { ConsentApiError, ConsentApiSuccess, ConsentRequest } from "../shared/consentSchema";

export async function submitConsent(payload: ConsentRequest): Promise<ConsentApiSuccess> {
  const response = await fetch("/api/consents", {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  const body = (await response.json()) as ConsentApiSuccess | ConsentApiError;

  if (!response.ok) {
    const error = new Error("Consent submission failed.") as Error & {
      details?: ConsentApiError;
    };
    error.details = body as ConsentApiError;
    throw error;
  }

  return body as ConsentApiSuccess;
}

